module.exports = "/_next/static/images/736eadc86d7ada4c784017eaeed28e56-nucommunity-lg@1x.jpg";